import CitySEOHead from "@/components/feature/CitySEOHead";
import CedarRapidsHeroSection from "./components/HeroSection";
import CedarRapidsStickyNav from "./components/StickyNav";
import CedarRapidsProcessingTimeSection from "./components/ProcessingTimeSection";
import CedarRapidsServicesSection from "./components/ServicesSection";
import CedarRapidsLocalAreaSection from "./components/LocalAreaSection";
import CedarRapidsTestimonialsSection from "./components/TestimonialsSection";
import CedarRapidsAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import CedarRapidsComparisonSection from "./components/ComparisonSection";
import CedarRapidsMistakesSection from "./components/MistakesSection";
import CedarRapidsHowItWorksSection from "./components/HowItWorksSection";
import CedarRapidsFAQSection, { faqs } from "./components/FAQSection";
import CedarRapidsHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import CedarRapidsFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Cedar Rapids, IA — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Cedar Rapids, IA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Linn County and eastern Iowa travelers.";
const pageKeywords = "expedited passport, emergency passport, Cedar Rapids passport, same day passport Cedar Rapids, fast passport Iowa, Linn County passport";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function CedarRapidsPage() {
  return (
    <>
      <CitySEOHead
        city="Cedar Rapids"
        state="Iowa"
        stateAbbr="IA"
        route="/cities/cedar-rapids"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Cedar Rapids, Iowa"
        geoPosition="41.9779;-91.6656"
        keywords={pageKeywords}
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Iowa"
        statePageRoute="/states/iowa"
        lastModified="2026-06-09"
        serviceAreaDesc="Fast Passport Center does not have a physical office in Cedar Rapids — we serve this area remotely. Emergency and expedited passport services as fast as 24 hours for Cedar Rapids and eastern Iowa travelers."
      />

      <div className="font-sans">
      <CedarRapidsHeroSection />
      <CedarRapidsStickyNav />
      <CedarRapidsProcessingTimeSection />
      <CedarRapidsLocalAreaSection />
      <CedarRapidsServicesSection />
      <CedarRapidsTestimonialsSection />
      <CedarRapidsAcceptanceFacilitiesSection />
      <CedarRapidsComparisonSection />
      <CedarRapidsMistakesSection />
      <CedarRapidsHowItWorksSection />
      <CedarRapidsFAQSection />
      <CedarRapidsHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/cedar-rapids" state="IA" />
      <CedarRapidsFinalCTA />
      </div>
    </>
  );
}